import './Home_card1.css'
import React from 'react';


const Home_card1 = (props) => {
    return ( 
        <>
<div className='home_card1'>
    <img className='home_card1_img' src={props.img} alt="" />
    <h4 className='home_card1_text1'>{props.title}</h4>
    <h6 className='home_card1_text2'>{props.subtitle}</h6>
</div>
        </>
     );
}
 
export default Home_card1;